import { Button, Divider, Drawer, Layout, Menu } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  checkVaiTroMenu,
  createMenuItems,
  CustomMenuItem,
  getLocalStorage,
  removeLocalStorage
} from "src/util/Commom";

import {
  AreaChartOutlined,
  ExceptionOutlined,
  FieldTimeOutlined,
  FileMarkdownOutlined,
  FileTextOutlined,
  HddOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SolutionOutlined,
  TeamOutlined,
  UserAddOutlined,
  FormOutlined
} from "@ant-design/icons";

const { Sider } = Layout;

interface listVaiTroAfter {
  isAdmin: boolean;
  listVaiTro: any[];
  isCollapsed: any;
  onClickCollapsed: any;
  windowSize: number;
  visible: boolean;
  onClickCloseDrawer: any;
  onClickMenu: any;
  menuSiderBar: any;
  pathName: string;
}

const SidebarAdmin: React.FC<listVaiTroAfter> = ({
  isAdmin,
  listVaiTro,
  isCollapsed,
  onClickCollapsed,
  windowSize,
  visible,
  onClickCloseDrawer,
  onClickMenu,
  menuSiderBar,
  pathName
}) => {
  const location = useLocation();
  const [menuItems, setMenuItems] = useState<CustomMenuItem[]>([]);
  const [activeHeaderChildren, setActiveHeaderChildren] = useState("");
  const paramHeader = pathName.split("/")[0];
  const itemMenu = menuSiderBar && menuSiderBar.map((value: any) => ({
    id: value.id,
    key: `idnhomtulieu/${value.id}`,
    label: value.tenNhomTuLieu,
    hienthi: checkVaiTroMenu(
      ["ADMIN", "DUYET_XUAT_BAN", "SOAN_THAO"],
      listVaiTro,
      isAdmin
    )
  }));

  const menuQuanTri = {
    "quan-tri": [
      {
        key: "quyen",
        icon: <HddOutlined />,
        label: "Quyền",
        hienthi: checkVaiTroMenu(["ADMIN"], listVaiTro, isAdmin),
        title: "Quyền"
      },
      {
        key: "vai-tro",
        icon: <SolutionOutlined />,
        label: "Vai trò",
        title: "Vai trò",
        hienthi: checkVaiTroMenu(["ADMIN"], listVaiTro, isAdmin)
      },
      {
        key: "chuc-vu",
        icon: <ExceptionOutlined />,
        label: "Chức vụ",
        title: "Chức vụ",
        hienthi: checkVaiTroMenu(["ADMIN"], listVaiTro, isAdmin)
      },
      {
        key: "phong-ban",
        icon: <TeamOutlined />,
        label: "Đơn vị/ Phòng ban",
        title: "Đơn vị/ Phòng ban",
        hienthi: checkVaiTroMenu(["ADMIN"], listVaiTro, isAdmin)
      },
      // {
      //   key: "phong-ban-table",
      //   icon: <TeamOutlined />,
      //   label: "Đơn vị/ Phòng ban table",
      //   title: "Đơn vị/ Phòng ban table",
      //   hienthi: checkVaiTroMenu(["ADMIN"], listVaiTro, isAdmin)
      // },
      {
        key: "nguoi-dung",
        icon: <UserAddOutlined />,
        label: "Người dùng",
        title: "Người dùng",
        hienthi: checkVaiTroMenu(["ADMIN"], listVaiTro, isAdmin)
      },
      {
        key: "nhom-tu-lieu",
        icon: <FileTextOutlined />,
        label: "Nhóm tài liệu",
        title: "Nhóm tài liệu",
        hienthi: checkVaiTroMenu(
          ["ADMIN", "DUYET_XUAT_BAN"],
          listVaiTro,
          isAdmin
        )
      },
      {
        key: "loai-tu-lieu",
        icon: <FileMarkdownOutlined />,
        label: "Loại tài liệu",
        title: "Loại tài liệu",
        hienthi: checkVaiTroMenu(
          ["ADMIN", "DUYET_XUAT_BAN"],
          listVaiTro,
          isAdmin
        )
      },
      {
        key: "thoi-han-luu-tru",
        icon: <FieldTimeOutlined />,
        label: "Thời hạn lưu trữ",
        title: "Thời hạn lưu trữ",
        hienthi: checkVaiTroMenu(
          ["ADMIN", "DUYET_XUAT_BAN"],
          listVaiTro,
          isAdmin
        )
      },
      {
        key: "tra-loi-gop-y",
        icon: <FormOutlined />,
        label: "Góp ý",
        title: "Góp ý",
        hienthi: checkVaiTroMenu(
          ["ADMIN", "DUYET_XUAT_BAN"],
          listVaiTro,
          isAdmin
        )
      }
    ]
  };

  const menuThongKe = {
    "thong-ke": [
      {
        key: "theo-nguoi-nhap",
        icon: <AreaChartOutlined />,
        label: "Theo người nhập",
        title: "Theo người nhập",
        hienthi: checkVaiTroMenu(
          ["ADMIN", "SOAN_THAO", "DUYET_XUAT_BAN"],
          listVaiTro,
          isAdmin
        )
      },
      {
        key: "tong-hop-theo-nhom-tu-lieu",
        icon: <AreaChartOutlined />,
        label: "Tổng hợp số liệu theo nhóm tài liệu",
        title: "Tổng hợp số liệu theo nhóm tài liệu",
        hienthi: checkVaiTroMenu(
          ["ADMIN", "SOAN_THAO", "DUYET_XUAT_BAN"],
          listVaiTro,
          isAdmin
        )
      }
    ]
  };

  const renderpathNames = () => {
    let key = "";
    switch (paramHeader) {
      case "video":
        key = "video";
        break;
      case "hinh-anh":
        key = "hinh-anh";
        break;
      case "tu-lieu":
        key = "tu-lieu";
        break;
      default:
        key = "";
    }
    return key;
  };

  const allMenu = {
    ...menuQuanTri,
    ...menuThongKe,
    [renderpathNames()]: itemMenu
  };
  // Khai báo rõ ràng kiểu của key
  type AllItemsKey = keyof typeof allMenu;
  useEffect(() => {
    const path = pathName.split("/")[0];
    const activeMenu = pathName.split("/").slice(1).join("/");
    setActiveHeaderChildren(activeMenu);
    const key =
      (Object.keys(allMenu) as AllItemsKey[]).find((key) =>
        path.includes(key as any)
      ) || "quan-tri";
    setMenuItems(allMenu[key]);
  }, [location, listVaiTro, menuSiderBar]);

  const onSelect = () => {
    if (getLocalStorage("dataFilter")) removeLocalStorage("dataFilter");
  };

  return (
    <>
      {windowSize < 992 ? (
        <Drawer
          title={
            <>
              <Button
                type="text"
                icon={
                  isCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />
                }
                onClick={onClickCloseDrawer}
                style={{
                  fontSize: "16px",
                  width: 50,
                  height: 50
                }}
              />
            </>
          }
          placement="left"
          closable={false}
          onClose={onClickCloseDrawer}
          open={visible}
          className="drawer-sider-admin"
          width={250}
        >
          <Menu
            mode="inline"
            style={{ height: "100%", borderRight: 0 }}
            items={createMenuItems(menuItems)}
            onClick={onClickMenu}
            onSelect={onSelect}
            selectedKeys={[activeHeaderChildren]}
          />
        </Drawer>
      ) : (
        <Sider
          collapsedWidth={isCollapsed && windowSize < 992 ? "0" : "50"}
          collapsed={isCollapsed}
          theme="light"
          width={220}
        >
          <div className="gx-site-logo-header">
            <Button
              type="text"
              icon={isCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={onClickCollapsed}
              style={{
                fontSize: "16px",
                width: 50,
                height: 50
              }}
            />
            {paramHeader === "home" ? (
              <div style={{ textAlign: "center", padding: 10, color: "#333" }}>
                <div
                  style={{
                    marginTop: "20%",
                    textAlign: "center",
                    display: isCollapsed ? "none" : ""
                  }}
                >
                  <img
                    alt="loader"
                    className="icon-trang-chu"
                    src="/office.svg"
                  />
                  <p style={{ textTransform: "uppercase" }}>
                    CSDL THƯ VIỆN ĐIỆN TỬ VỀ CÔNG TÁC DÂN TỘC TRÊN ĐỊA BÀN TỈNH
                    QUẢNG NAM
                  </p>
                  <p>
                    <a href="/trang-chu" target="_blank">Đi đến Cổng khai thác dữ liệu</a>
                  </p>
                </div>
                <Divider />
              </div>
            ) : (
              <Menu
                mode="inline"
                className="QTI-menu-sidebar-wrap"
                style={{ height: "100%", borderRight: 0 }}
                items={createMenuItems(menuItems)}
                onClick={onClickMenu}
                onSelect={onSelect}
                selectedKeys={[activeHeaderChildren]}
              />
            )}
          </div>
        </Sider>
      )}
    </>
  );
};
export default SidebarAdmin;
